import React from "react";
import "./App.css";

import PipelineConfiguratorContainer from "./components/pipelineConfigurator/pipelineConfiguratorContainer";

function App() {
  return (
    <div className="App">
      <PipelineConfiguratorContainer></PipelineConfiguratorContainer>
    </div>
  );
}

export default App;
